import { Component, OnInit } from '@angular/core';
import { ICardLink, IInvitation } from '@app/models/signup';
import { eInvitation } from '@app/signup/steps/shared/steps.model';
import { SetLangSuccessful } from '@app/store/actions/cart.action';
import { translate } from '@ngneat/transloco';
import { Actions, ofActionCompleted } from '@ngxs/store';

@Component({
  selector: 'error-already-accepted',
  templateUrl: './already-accepted.component.html',
  styleUrls: ['./already-accepted.component.scss', '../signup-errors.component.scss'],
})
export class ErrorAlreadyAcceptedComponent implements OnInit {
  eInvitation = eInvitation;
  state = window['CURRENT_STATE'];
  invitation: IInvitation = window['INVITATION'];
  endpoints = window['ENDPOINTS'];

  cardLinkData: ICardLink = {
    link: '',
    img: '',
    text: '',
    name: '',
  };

  constructor(private actions: Actions) {}

  ngOnInit() {
    this.refreshData();
    this.actions.pipe(ofActionCompleted(SetLangSuccessful)).subscribe(() => {
      this.refreshData();
    });
  }

  refreshData() {
    if (this.state === eInvitation.Account) {
      this.cardLinkData = {
        link: this.endpoints.manager + '/v3/' + this.invitation.account?.id,
        img: '/assets/images/ui/tools/ik-management-users.svg',
        text: translate("Acceder a l'organisation"),
        name: this.invitation.account?.organization_name,
      };
    } else if (this.state === eInvitation.Ksuite) {
      this.cardLinkData = {
        link: this.endpoints.manager + '/v3/' + this.invitation.account?.id,
        img: '/assets/images/ui/tools/ik-management-users.svg',
        text: translate("Acceder a l'organisation"),
        name: this.invitation.account?.organization_name,
      };
    } else if (this.state === eInvitation.Drive) {
      this.cardLinkData = {
        link: this.endpoints.drive,
        img: '/assets/images/ui/tools/ik-drive.svg',
        text: translate('Acceder au kDrive'),
        name: this.invitation.extras.drive.name,
      };
    } else if (this.state === eInvitation.Webmail) {
      this.cardLinkData = {
        link: this.endpoints.workspace,
        img: '/assets/images/ui/tools/ik-mail.svg',
        text: translate('Acceder a votre adresse email'),
        name: this.invitation.extras.webmail.email,
      };
    } else if (this.state === eInvitation.Transfer) {
      this.cardLinkData = {
        link: this.endpoints.manager + '/v3/' + this.invitation.account?.id,
        img: '/assets/images/ui/tools/ik-management-users.svg',
        text: translate("Acceder a l'organisation"),
        name: this.invitation.account?.organization_name,
      };
    } else if (this.state === eInvitation.KChat) {
      this.cardLinkData = {
        link: this.endpoints.manager,
        img: '/assets/images/ui/tools/ik-management-users.svg',
        text: translate("Acceder a l'organisation"),
        name: this.invitation.account?.organization_name,
      };
    }
  }
}
